import React from 'react';
import reactLogo from '../Assets/react-logo.png';
import tailwindtLogo from '../Assets/tailwind-logo.png';
import penguin from '../Assets/penguin.gif';
import { ImGithub } from 'react-icons/im';
import { BsLinkedin } from 'react-icons/bs';
import { AiFillTwitterCircle } from 'react-icons/ai';


const Footer = () => {
    return (
        <div>

<footer className="flex flex-col gap-6 sm:gap-0 items-center justify-between px-6 py-4 bg-[#111111] min-h-[100px] sm:flex-row">
                <div>
                <p className='text-gray-400 flex justify-center items-center'>Coded by <span><img src={penguin} alt="" /></span></p>
                <p className="text-lg font-bold text-gray-800 dark:text-white hover:text-gray-700 dark:hover:text-gray-300"> &lt; Hayeul Tanjib /&gt;</p>
                </div>
                
                <div className='flex flex-col items-center justify-center'>
                <p className='text-white text-lg py-2'>Let's Connect</p>
                <div className='flex items-center justify-center gap-3'>
                <a href="https://twitter.com/Hayeul_Tanjib" target={'_blank'}><AiFillTwitterCircle className='text-[#4DB5F5] text-2xl'/></a>
                <a href="https://github.com/HayeulTanjib" target={'_blank'}><ImGithub className='text-white text-xl'/></a>
                <a href="https://www.linkedin.com/in/hayeul-tanjib-rupok/" target={'_blank'}><BsLinkedin className='text-[#3A80D3] text-xl'/></a>
                </div>
                </div>

                <div className="">
                    <p className='text-white'>Built With ❤️</p>
                    <div className='flex justify-center items-center gap-3'>
                        <img src={tailwindtLogo} className="w-7" alt="" />
                        <img src={reactLogo} className="w-7" alt="" />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;